export default __webpack_public_path__ + "static/media/Semcasting_3rdPartySegments_Master_Taxonomy_ADS.0dafc0db.xlsx";